import { createStore } from "vuex";
import { auth } from "./auth.module";
import { keepSignedIn } from "./keepSignIn.module";

const store = createStore({
  modules: {
    auth,
    keepSignedIn
  },
});

export default store;
